/* tslint:disable */
/* eslint-disable */
/**
 * Riders API
 * Internal Riders TV API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetRiderTabs200ResponseTabsInnerStatus
 */
export interface GetRiderTabs200ResponseTabsInnerStatus {
    /**
     * 
     * @type {string}
     * @memberof GetRiderTabs200ResponseTabsInnerStatus
     */
    name: string;
}

/**
 * Check if a given object implements the GetRiderTabs200ResponseTabsInnerStatus interface.
 */
export function instanceOfGetRiderTabs200ResponseTabsInnerStatus(value: object): value is GetRiderTabs200ResponseTabsInnerStatus {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function GetRiderTabs200ResponseTabsInnerStatusFromJSON(json: any): GetRiderTabs200ResponseTabsInnerStatus {
    return GetRiderTabs200ResponseTabsInnerStatusFromJSONTyped(json, false);
}

export function GetRiderTabs200ResponseTabsInnerStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetRiderTabs200ResponseTabsInnerStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function GetRiderTabs200ResponseTabsInnerStatusToJSON(json: any): GetRiderTabs200ResponseTabsInnerStatus {
    return GetRiderTabs200ResponseTabsInnerStatusToJSONTyped(json, false);
}

export function GetRiderTabs200ResponseTabsInnerStatusToJSONTyped(value?: GetRiderTabs200ResponseTabsInnerStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

